import { render, staticRenderFns } from "./openid-query.vue?vue&type=template&id=375ce58b&scoped=true"
import script from "./openid-query.vue?vue&type=script&lang=js"
export * from "./openid-query.vue?vue&type=script&lang=js"
import style0 from "./openid-query.vue?vue&type=style&index=0&id=375ce58b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375ce58b",
  null
  
)

export default component.exports